var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var YearPicker = require('./yearPicker.jsx');
var MonthPicker = require('./monthPicker.jsx');
var DayPicker = require('./dayPicker.jsx');

var DatePicker = createReactClass({
    getInitialState: function(){
        if(this.props.year){
            return {
                year: this.props.year,
                month: this.props.month
            }
        }else{
            var now = new Date();
            return {
                year: now.getFullYear(),
                month: 1
            };
        }
    },

    componentDidMount: function(){
        this.handleDateChange();
    },

    handleDateChange: function(){
        this.props.onDateChange(ReactDOM.findDOMNode(this.refs.month).value, ReactDOM.findDOMNode(this.refs.day).value, ReactDOM.findDOMNode(this.refs.year).value);
    },

    handleMonthChange: function(month){
        this.setState(Object.assign({}, this.state, {month: month}));
        this.handleDateChange();
    },

    handleDayChange: function(day){
        this.handleDateChange();
    },

    handleYearChange: function(year){
        this.setState(Object.assign({}, this.state, {year: year}));
        this.handleDateChange();
    },

  render: function(){
    return (
        <div className="date-picker input-field-wrapper">
            <div className="input-field">
                <label className="heading">Month</label>
                <div className="select-container">
                    <MonthPicker month={this.props.month} ref="month" onMonthChange={this.handleMonthChange} />
                </div>
            </div>
            <div className="input-field">
                <label className="heading">Day</label>
                <div className="select-container">
                    <DayPicker day={this.props.day} ref="day" year={this.state.year} month={this.state.month} onDayChange={this.handleDayChange} />
                </div>
            </div>
            <div className="input-field">
                <label className="heading">Year</label>
                <div className="select-container">
                    <YearPicker year={this.props.year} ref="year" startYear="1900" onYearChange={this.handleYearChange} />
                </div>
            </div>
        </div>
    );
  }
});

module.exports = DatePicker;



// WEBPACK FOOTER //
// ./src/common/routes/components/datePicker.jsx